import React, {Component} from 'react';
import {Image} from 'react-konva';

/** @class BoothIcon
  * Component that renders a BoothIcon in a hall.
  */
export default class BoothIcon extends Component {
  /** @constructor
    * Constructs a new instance of BoothIcon
    */
  constructor(props) {
    super(props);
    this.spots = {}
    this.state = {image: null}
  }
  /** @method componentWillMount
    * Loads the BoothIcon image.
    */
  componentWillMount() {
    var image = new window.Image();
    image.onload = () => {
      this.setState({image: image});
    }
    image.src = this.props.icon;
  }
  /** @method render
    * Renders the boothIcon
    */
  render() {
    return (
      <Image image={this.state.image}
        x={this.props.x}
        y={this.props.y}
        scaleX={this.props.scale}
        scaleY={this.props.scale}
        onMouseEnter={()=>{
          document.body.style.cursor = 'pointer';
        }}
        onMouseLeave={()=>{
          document.body.style.cursor = 'default';
        }}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/hall/booth-icon.js